<template>
  <div class="foot-wrap">
    <div class="foot wrap">
      <div class="copyright">
        <div>
          <span>copyright © 2019上海烛龙影视文化有限公司</span>
          <a target="_blank" href="http://www.beian.miit.gov.cn/"
            style="font-size: 12px;color:rgba(255, 255, 255, 1);cursor:pointer;text-decoration:none;">
          <span>{{beian}}</span>
          </a>
          <img src="/static/img/a.gif" style="width:12px;margin-left:30px;"/>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015407"
            style="font-size: 12px;color:rgba(255, 255, 255, 1);cursor:pointer;text-decoration:none;">
            沪公网安备 31011502015407号
          </a>
        </div>
      </div>
      <div class="foot-logo" @click="doRouter('/home')"></div>
      <div class="logo-bg"></div>
      <div class="foot-project">
        <div class="pro-title" @click="doRouter('/project-introduction')">项目介绍</div>
        <div
          class="pro-name"
          @click="doRouter(`/project-detail/${i.id}`)"
          v-for="(i, inx) in projects"
          :key="inx"
        >{{i.thumb_title}}</div>
      </div>
      <div class="foot-project left55">
        <div class="pro-title" @click="doRouter('/about-us')">关于我们</div>
        <div class="pro-name" @click="doRouter('/about-us', 'company')">公司简介</div>
        <div class="pro-name" @click="doRouter('/about-us', 'author')">作家简介</div>
        <div class="pro-name" @click="doRouter('/contact-us')">联系我们</div>
      </div>
      <div class="wechat-weibo">
        <div class="focus">关注我们</div>
        <div>
          <i class="iconfont icon-wechat icon-common" @mouseenter="showCode(true)" @mouseleave="showCode(false)"></i>
          <i class="iconfont icon-weibo icon-common" @click="toWeibo"></i>
        </div>
        <div class="qrcode" :class="code ? 'active' : ''">
          <img :src="imgRoot+qrcode" alt="qrcode">
        </div>
      </div>
      <div class="logo-en">&nbsp;ZULON ENTERTAINMENT</div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  data: _ => ({
    code: false,
    beian: '沪ICP备19005937号-1',
    qrcode: '/uploads/20190324/a879b5a96d6064354318539319844d83.jpg'
  }),
  methods: {
    doRouter (path, hash) {
      this.menuStatus = false
      path = hash ? `${path}#${hash}` : path
      this.$router.push({ path })
    },
    toWeibo () {
      window.open('https://weibo.com/u/3555961815', '_blank')
    },
    showCode (isShow) {
      this.code = isShow
    }
  },
  computed: {
    ...mapState(['projects'])
  },
  created () {
    if (window.config && window.config.site && window.config.site.beian) {
      this.beian = window.config.site.beian
    }
    if (window.config && window.config.site && window.config.site.wechat_qrcode) {
      this.qrcode = window.config.site.wechat_qrcode
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.foot-wrap {
  height: 366px;
  padding: 50px 0 0;
  box-sizing: border-box;
  background: rgba(39, 43, 55, 1);
  .foot {
    position: relative;
    height: 100%;
    .copyright {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
      opacity: 0.5;
      position: absolute;
      bottom: 14px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
      > div {
        display: inline-block;
        > span:first-child {
          margin-right: 30px;
        }
      }
    }
    .foot-logo {
      position: absolute;
      width: 200px;
      height: 62px;
      background: url(/static/img/logo.png);
      background-size:100% 100%;
      cursor: pointer;
    }
    .logo-bg{
      width: 918px;
      height: 332px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      background: url(/static/img/foot-bg.png);
      background-size: 100% 100%;
    }
    .foot-project{
      left: 440px;
      top: 15px;
      position: absolute;
      &.left55{
        left: 736px;
      }
      .pro-title{
        font-size:16px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-bottom: 26px;
        cursor: pointer;
      }
      .pro-name{
        font-size:14px;
        font-weight:500;
        color:rgba(255,255,255,1);
        margin-bottom: 6px;
        opacity:0.7;
        cursor: pointer;
        transition: opacity .5s;
        &:hover{
          opacity:1;
        }
      }
    }
    .wechat-weibo{
      position: absolute;
      left: 1034px;
      top: 15px;
      .focus{
        font-size:16px;
        font-weight:bold;
        color:rgba(255,255,255,1);
      }
      .icon-common{
        cursor: pointer;
        position: absolute;
        top: 30px;
        left: 46px;
        opacity:0.7;
        color: #fff;
        transition: all .5s;
        font-size: 20px;
        &:hover{
          opacity: 1;
          font-size: 30px;
        }
        &.icon-wechat{
          left: 0;
          font-size: 24px;
          &:hover{
            opacity: 1;
            font-size: 32px;
          }
        }
      }
      .qrcode{
        width: 100px;
        height: 100px;
        position: absolute;
        top: 80px;
        opacity: 0;
        transition: opacity .5s;
        z-index: 1;
        >img{
          position: absolute;
          width: 100%;
          height: 100%;
        }
        &.active{
          opacity: 1;
        }
      }
    }
    .logo-en{
      position: absolute;
      bottom: 90px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-size: 12px;
      opacity:0.5;
      line-height: 16px;
      letter-spacing: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue